module.exports = __webpack_public_path__ + "bd641d3ff97976b4668a9bea96d6eec1.woff";